export default __webpack_public_path__ + "ed2159bbfd12babdff511bae7a4d0543.png";